import { useEffect } from "react";

/** Fixed-position toast that auto-dismisses. Matches the Polls/Announcements toast. */
export function Toast({ tone = "success", children, onDone, duration = 3500 }) {
  useEffect(() => {
    if (!onDone) return undefined;
    const timer = setTimeout(onDone, duration);
    return () => clearTimeout(timer);
  }, [onDone, duration]);

  const background =
    tone === "error"
      ? "var(--color-error)"
      : tone === "warning"
        ? "var(--status-warning-fg)"
        : "var(--color-success)";

  return (
    <div
      role="status"
      className="fixed top-6 left-1/2 -translate-x-1/2 z-[500] flex items-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold text-white shadow-[0_10px_30px_-8px_rgba(0,0,0,0.35)] max-w-[90vw]"
      style={{ background }}
    >
      {children}
    </div>
  );
}

export default Toast;
